export const BP_SM = 480;
export const BP_MD = 767;
export const BP_LG = 1024;
export const BP_XL = 1440;
